module.exports = __webpack_public_path__ + "img/png_title1.bd1650ad.png";